(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-navigation"] && !Shopify.designMode) return;
  try {
    
  function resetCategoryPanelVideos(panel) {
    window.clearTimeout(panel.categoryVideoTimer);

    panel.querySelectorAll('.category-navigation__video').forEach(function (video) {
      video.pause();
      if (video.readyState > 0) video.currentTime = 0;
      video.onended = null;
      video.ontimeupdate = null;
      video.onerror = null;
      video.onloadedmetadata = null;
      video.closest('.category-navigation__media-item').classList.remove('category-navigation__media-item--playing');
    });
  }

  function getCategoryPanelPlaylist(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('.category-navigation__video'));
  }

  function playCategoryPanelPlaylistItem(panel, playlist, videoIndex) {
    var video = playlist[videoIndex];

    if (!video) return;

    var mediaItem = video.closest('.category-navigation__media-item');
    var hasMovedToNextVideo = false;

    function playNextCategoryPanelVideo() {
      if (hasMovedToNextVideo) return;

      hasMovedToNextVideo = true;
      video.pause();
      video.onended = null;
      video.ontimeupdate = null;
      video.onerror = null;
      video.onloadedmetadata = null;
      if (video.readyState > 0) video.currentTime = 0;
      mediaItem.classList.remove('category-navigation__media-item--playing');
      playCategoryPanelPlaylistItem(panel, playlist, (videoIndex + 1) % playlist.length);
    }

    function beginCategoryPanelVideoPlayback() {
      if (hasMovedToNextVideo) return;

      if (video.readyState > 0) video.currentTime = 0;

      var playPromise = video.play();

      if (playPromise) {
        playPromise.catch(playNextCategoryPanelVideo);
      }
    }

    mediaItem.classList.add('category-navigation__media-item--playing');

    video.onended = playNextCategoryPanelVideo;
    video.onerror = playNextCategoryPanelVideo;

    if (video.readyState === 0) {
      video.onloadedmetadata = beginCategoryPanelVideoPlayback;
      video.load();
    } else {
      beginCategoryPanelVideoPlayback();
    }
  }

  function startCategoryPanelVideos(panel) {
    resetCategoryPanelVideos(panel);
    var playlist = getCategoryPanelPlaylist(panel);

    if (!playlist.length) return;

    panel.categoryVideoTimer = window.setTimeout(function () {
      playCategoryPanelPlaylistItem(panel, playlist, 0);
    }, 1000);
  }

  function initialiseCategoryPanelVideos(section) {
    section.querySelectorAll('[data-category-panel]:not([hidden])').forEach(startCategoryPanelVideos);
    scheduleCategoryCarousel(section);
  }

  function clearCategoryCarousel(section) {
    window.clearTimeout(section.categoryCarouselTimer);
    section.categoryCarouselTimer = null;
  }

  function scheduleCategoryCarousel(section) {
    clearCategoryCarousel(section);

    if (section.categoryCarouselStopped) return;

    var carousel = section.querySelector('[data-category-carousel="true"]');
    var controls = section.querySelectorAll('[data-category-panel-control]');
    var delay = carousel ? Number(carousel.getAttribute('data-category-carousel-delay')) : 0;

    if (!carousel || controls.length < 2 || !delay) return;

    section.categoryCarouselTimer = window.setTimeout(function () {
      var activeIndex = 0;

      controls.forEach(function (control, index) {
        if (control.getAttribute('aria-pressed') === 'true') activeIndex = index;
      });

      var nextControl = controls[(activeIndex + 1) % controls.length];
      showCategoryPanel(section, nextControl.getAttribute('data-category-panel-control'));
    }, delay);
  }

  function showCategoryPanel(section, panelId, animate) {
    var panel = section.querySelector('[data-category-panel="' + panelId + '"]');
    var control = section.querySelector('[data-category-panel-control="' + panelId + '"]');
    var activePanel = section.querySelector('[data-category-panel]:not([hidden])');
    var carousel = section.querySelector('[data-category-carousel]');
    var transitionDuration = carousel ? Number(carousel.getAttribute('data-category-panel-transition-duration')) : 0;

    if (!panel || !control) return false;

    section.querySelectorAll('[data-category-panel-control]').forEach(function (item) {
      var isActive = item === control;
      item.classList.toggle('category-navigation__pill--active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });

    window.clearTimeout(section.categoryPanelTransitionTimer);

    if (activePanel && activePanel !== panel && animate !== false) {
      activePanel.classList.add('category-navigation__feature--leaving');
      panel.classList.add('category-navigation__feature--entering');
      panel.hidden = false;
      void panel.offsetWidth;
      panel.classList.remove('category-navigation__feature--entering');

      section.categoryPanelTransitionTimer = window.setTimeout(function () {
        section.querySelectorAll('[data-category-panel]').forEach(function (item) {
          if (item === panel) return;

          item.hidden = true;
          item.classList.remove('category-navigation__feature--entering');
          item.classList.remove('category-navigation__feature--leaving');
          resetCategoryPanelVideos(item);
        });
      }, transitionDuration);
    } else {
      section.querySelectorAll('[data-category-panel]').forEach(function (item) {
        item.hidden = item !== panel;
        item.classList.remove('category-navigation__feature--leaving');
        resetCategoryPanelVideos(item);
      });
    }

    var select = section.querySelector('[data-category-select]');

    if (select) select.value = '#' + panelId;

    startCategoryPanelVideos(panel);
    scheduleCategoryCarousel(section);

    return true;
  }

  document.querySelectorAll('.category-navigation').forEach(initialiseCategoryPanelVideos);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target.classList.contains('category-navigation')) return;

    initialiseCategoryPanelVideos(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target.classList.contains('category-navigation')) return;

    event.target.querySelectorAll('[data-category-panel]').forEach(resetCategoryPanelVideos);
    clearCategoryCarousel(event.target);
    window.clearTimeout(event.target.categoryPanelTransitionTimer);
  });

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-category-panel-control]');

    if (!control) return;

    var section = control.closest('.category-navigation');
    section.categoryCarouselStopped = true;
    clearCategoryCarousel(section);
    showCategoryPanel(section, control.getAttribute('data-category-panel-control'), false);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-category-select]');

    if (!select || !select.value) return;

    var section = select.closest('.category-navigation');
    var panelId = select.value.substring(1);

    section.categoryCarouselStopped = true;
    clearCategoryCarousel(section);

    if (!showCategoryPanel(section, panelId, false)) {
      window.location.href = select.value;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-carousel"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionProductCarousel(section) {
    var track = section.querySelector('[data-collection-product-carousel-track]');
    var controls = section.querySelector('[data-collection-product-carousel-controls]');

    if (!track || !controls || track.dataset.carouselInitialized === 'true') return;

    var previousButton = controls.querySelector('[data-collection-product-carousel-previous]');
    var nextButton = controls.querySelector('[data-collection-product-carousel-next]');
    var currentLabel = controls.querySelector('[data-collection-product-carousel-current]');
    var totalLabel = controls.querySelector('[data-collection-product-carousel-total]');
    var cards = Array.from(track.querySelectorAll('[data-collection-product-carousel-card]'));
    var animationFrame;
    var pagePositions = [0];
    var totalPages = 1;

    track.dataset.carouselInitialized = 'true';

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function calculatePages() {
      var maxScroll = getMaxScroll();
      var gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var cardWidth = cards.length ? cards[0].getBoundingClientRect().width : track.clientWidth;
      var productsPerPage = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));

      totalPages = Math.max(1, Math.ceil(cards.length / productsPerPage));
      pagePositions = [];

      for (var pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
        var cardIndex = Math.min(pageIndex * productsPerPage, cards.length - 1);
        pagePositions.push(Math.min(cards[cardIndex].offsetLeft, maxScroll));
      }
    }

    function getCurrentPageIndex() {
      return pagePositions.reduce(function (closestIndex, position, index) {
        return Math.abs(position - track.scrollLeft) < Math.abs(pagePositions[closestIndex] - track.scrollLeft)
          ? index
          : closestIndex;
      }, 0);
    }

    function updateCarousel() {
      calculatePages();

      var maxScroll = getMaxScroll();
      var currentPageIndex = getCurrentPageIndex();
      var currentPage = currentPageIndex + 1;

      currentLabel.textContent = currentPage;
      totalLabel.textContent = totalPages;
      previousButton.disabled = currentPageIndex === 0;
      nextButton.disabled = currentPageIndex === totalPages - 1 || track.scrollLeft >= maxScroll - 1;
      controls.hidden = totalPages <= 1;
    }

    function scheduleUpdate() {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateCarousel);
    }

    function changePage(direction) {
      calculatePages();

      var currentPage = getCurrentPageIndex();
      var nextPage = Math.max(0, Math.min(totalPages - 1, currentPage + direction));
      var nextPosition = pagePositions[nextPage];

      track.scrollTo({ left: nextPosition, behavior: 'smooth' });
    }

    previousButton.addEventListener('click', function () { changePage(-1); });
    nextButton.addEventListener('click', function () { changePage(1); });
    track.addEventListener('scroll', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(track);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    updateCarousel();
  }

  function initializeCollectionProductCarousels(root) {
    if (root.matches && root.matches('.collection-product-carousel')) {
      initializeCollectionProductCarousel(root);
    }

    root.querySelectorAll('.collection-product-carousel').forEach(initializeCollectionProductCarousel);
  }

  initializeCollectionProductCarousels(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeCollectionProductCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  function initialiseCustomerReviewsCarousel(section) {
    var slider = section.querySelector('[data-customer-reviews-slider]');
    var track = section.querySelector('[data-customer-reviews-track]');

    if (!slider || !track) return;

    if (slider.customerReviewsCleanup) {
      slider.customerReviewsCleanup();
    }

    var previousButton = slider.querySelector('[data-customer-reviews-previous]');
    var nextButton = slider.querySelector('[data-customer-reviews-next]');
    var frame = null;

    function getScrollStep() {
      var card = track.querySelector('.customer-reviews__card');
      var group = track.querySelector('.customer-reviews__group');
      var gap = group ? parseFloat(window.getComputedStyle(group).gap) || 0 : 0;

      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function updateButtons() {
      var maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var hasOverflow = maximumScroll > 1;

      if (previousButton) {
        previousButton.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 1;
        previousButton.setAttribute('aria-disabled', previousButton.disabled ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.hidden = !hasOverflow;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 1;
        nextButton.setAttribute('aria-disabled', nextButton.disabled ? 'true' : 'false');
      }
    }

    function scheduleButtonUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateButtons);
    }

    function moveCarousel(direction) {
      track.scrollBy({
        left: direction * getScrollStep(),
        behavior: 'smooth'
      });
    }

    function showPrevious() {
      moveCarousel(-1);
    }

    function showNext() {
      moveCarousel(1);
    }

    if (previousButton) previousButton.addEventListener('click', showPrevious);
    if (nextButton) nextButton.addEventListener('click', showNext);
    track.addEventListener('scroll', scheduleButtonUpdate, { passive: true });
    window.addEventListener('resize', scheduleButtonUpdate);

    slider.customerReviewsCleanup = function() {
      if (previousButton) previousButton.removeEventListener('click', showPrevious);
      if (nextButton) nextButton.removeEventListener('click', showNext);
      track.removeEventListener('scroll', scheduleButtonUpdate);
      window.removeEventListener('resize', scheduleButtonUpdate);
      if (frame) window.cancelAnimationFrame(frame);
      delete slider.customerReviewsCleanup;
    };

    updateButtons();
  }

  function initialiseCustomerReviewsCarousels(root) {
    if (root.classList && root.classList.contains('customer-reviews')) {
      initialiseCustomerReviewsCarousel(root);
      return;
    }

    root.querySelectorAll('.customer-reviews').forEach(initialiseCustomerReviewsCarousel);
  }

  initialiseCustomerReviewsCarousels(document);

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target.classList.contains('customer-reviews')) return;
    initialiseCustomerReviewsCarousel(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (!event.target.classList.contains('customer-reviews')) return;

    var slider = event.target.querySelector('[data-customer-reviews-slider]');
    if (slider && slider.customerReviewsCleanup) slider.customerReviewsCleanup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function initialiseFaq(section) {
    var accordion = section.querySelector('.faq__accordion');

    if (!accordion || accordion.dataset.initialized === 'true') return;

    accordion.dataset.initialized = 'true';

    var items = Array.prototype.slice.call(
      accordion.querySelectorAll('.faq__item')
    );
    var initiallyOpenItems = items.filter(function(item) {
      return item.open;
    });

    initiallyOpenItems.slice(1).forEach(function(item) {
      item.open = false;
    });

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (!item.open) return;

        items.forEach(function(otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  }

  document.querySelectorAll('.faq').forEach(initialiseFaq);

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target.classList.contains('faq')) return;

    initialiseFaq(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
